<template>
  <div>
    <span :class="`text-xs me-1 text--disabled `">
      {{ functions.formatDate(dataCadastro, { hour: 'numeric', minute: 'numeric' }) }}
    </span>
  </div>
</template>

<script>
import { formatDate } from '@core/utils/filter'

export default {
  props: {
    dataCadastro: {
      type: String,
      required: true,
    },
    isMensagemDoAtendente: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    return {
      functions: {
        formatDate,
      },
    }
  },
}
</script>
